module.exports = __webpack_public_path__ + "img/dbcode.1c547cf5.jpg";